"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var manifest_loader_1 = require("./manifest-loader");
var NetworkManifestLoader = (function (_super) {
    __extends(NetworkManifestLoader, _super);
    function NetworkManifestLoader(manifestParser, requestHandler) {
        var _this = _super.call(this) || this;
        _this.manifestParser = manifestParser;
        _this.requestHandler = requestHandler;
        return _this;
    }
    NetworkManifestLoader.prototype.getManifest = function () {
        var _this = this;
        var lastLoadURL = this.lastNativeLoadData.cdn.url;
        return this.requestManifest(lastLoadURL).then(function (responseXml) {
            try {
                return _this.manifestParser.parseXml(lastLoadURL, responseXml);
            }
            catch (error) {
                return null;
            }
        });
    };
    NetworkManifestLoader.prototype.requestManifest = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestHandler.getArrayBuffer(url, function (xmlString) { return resolve(client_lib_js_player_framework_utils_1.parse(xmlString)); }, function (error) { return reject(error); });
        });
    };
    return NetworkManifestLoader;
}(manifest_loader_1.LastNativeLoadManifestLoader));
exports.NetworkManifestLoader = NetworkManifestLoader;
